var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "flex-nowrap content-row",
    attrs: {
      "align": "stretch",
      "no-gutters": ""
    }
  }, [_c('navigation', {
    staticClass: "sidebar",
    attrs: {
      "selected": _vm.currentTab
    }
  }), _c(_vm.AmazonTransparencyContent, {
    ref: _vm.currentTab,
    tag: "component",
    staticClass: "flex-shrink-1 content flex-grow-1"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }